export default "__VITE_ASSET__C7X4W3Zd__"